import React, { useState } from 'react';
import { Play } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';

const films = [
  { id: 'KTLcIqddWSE' },
  { id: 'tSAyeoBfnOk' },
  { id: 'TSGJyA-meX8' },
  { id: 'OynwPvMB2i0' },
  { id: '1DXk4bMe3WM' },
  { id: 'ylVnOyaa76E' },
];

const photos = [
  'https://customer-assets.emergentagent.com/job_8d44df25-0f67-4d0d-b916-c24ae1fa8d16/artifacts/lgsxk5pq_Bonnie__Josh_SP_.jpg',
  'https://customer-assets.emergentagent.com/job_8d44df25-0f67-4d0d-b916-c24ae1fa8d16/artifacts/2fbxfqwa_CHARLEY%20%26%20FABIO%20SP%2015-08-25%20%20040.jpg',
  'https://customer-assets.emergentagent.com/job_8d44df25-0f67-4d0d-b916-c24ae1fa8d16/artifacts/1qkcz52g_EMMA__MICHAEL_101023___471.jpg',
  'https://customer-assets.emergentagent.com/job_8d44df25-0f67-4d0d-b916-c24ae1fa8d16/artifacts/49pnxgu0_JESS%20%26%20PETE%2022-05-25%20%20384.jpg',
  'https://customer-assets.emergentagent.com/job_8d44df25-0f67-4d0d-b916-c24ae1fa8d16/artifacts/7x81ib5v_Oyin%20%26%20David%20Preview-24.jpg',
  'https://customer-assets.emergentagent.com/job_wve-wedding-showcase/artifacts/4tj3d52l_Helen%20%26%20Daniel%2014-07-25%20%20009.jpg',
  'https://customer-assets.emergentagent.com/job_wve-wedding-showcase/artifacts/7jvqirjn_JESS%20%26%20PETE%2022-05-25%20%20396.jpg',
  'https://customer-assets.emergentagent.com/job_wve-wedding-showcase/artifacts/aiky4ekf_Paige__Richard_070724__625.jpg',
  'https://customer-assets.emergentagent.com/job_wve-wedding-showcase/artifacts/tohymtf9_ROBYN%20%26%20CHARLIE%2021-08-25%20044.jpg',
  'https://customer-assets.emergentagent.com/job_8d44df25-0f67-4d0d-b916-c24ae1fa8d16/artifacts/3xdtp1cg_Preview-45.jpg',
  'https://customer-assets.emergentagent.com/job_8d44df25-0f67-4d0d-b916-c24ae1fa8d16/artifacts/ttll3q8t_Paige__Richard_070724__701.jpg',
  'https://customer-assets.emergentagent.com/job_8d44df25-0f67-4d0d-b916-c24ae1fa8d16/artifacts/52g6cs4z_London%20Wedding%20Previews-21.jpg',
  'https://customer-assets.emergentagent.com/job_8d44df25-0f67-4d0d-b916-c24ae1fa8d16/artifacts/yqdigxmd_Preview-11.jpg',
  'https://customer-assets.emergentagent.com/job_8d44df25-0f67-4d0d-b916-c24ae1fa8d16/artifacts/c5um0kej_Preview-29.jpg',
];

const Portfolio = () => {
  const [activeVideo, setActiveVideo] = useState(null);
  const [lightboxPhoto, setLightboxPhoto] = useState(null);

  return (
    <section id="portfolio" data-testid="portfolio-section" className="py-24" style={{ backgroundColor: '#111' }}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
        <div className="text-center mb-16">
          <p className="text-gold text-sm font-semibold uppercase tracking-widest mb-4">Our work</p>
          <h2 className="font-serif text-4xl sm:text-5xl text-white mb-4">
            Real weddings. Real love. Real tears.
          </h2>
          <p className="text-white/60 text-lg">Every film is different. Because every couple is.</p>
        </div>

        <Tabs defaultValue="films" className="w-full">
          <TabsList className="grid w-full max-w-sm mx-auto grid-cols-2 mb-12 bg-white/10 border border-white/20 rounded-full p-1 h-auto">
            <TabsTrigger
              value="films"
              className="rounded-full py-2.5 text-sm text-white/70 data-[state=active]:bg-[#C8A967] data-[state=active]:text-black data-[state=active]:font-semibold transition-all"
            >
              Wedding Films
            </TabsTrigger>
            <TabsTrigger
              value="photos"
              className="rounded-full py-2.5 text-sm text-white/70 data-[state=active]:bg-[#C8A967] data-[state=active]:text-black data-[state=active]:font-semibold transition-all"
            >
              Photography
            </TabsTrigger>
          </TabsList>

          <TabsContent value="films">
            {activeVideo && (
              <div className="mb-8 animate-fade-up">
                <div className="aspect-video rounded-2xl overflow-hidden shadow-2xl">
                  <iframe
                    width="100%"
                    height="100%"
                    src={`https://www.youtube.com/embed/${activeVideo}?autoplay=1&rel=0&modestbranding=1`}
                    title="Wedding Film"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
              </div>
            )}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {films.map((film) => (
                <div
                  key={film.id}
                  data-testid={`film-${film.id}`}
                  className={`relative aspect-video rounded-xl overflow-hidden cursor-pointer group ${
                    activeVideo === film.id ? 'ring-2 ring-gold' : ''
                  }`}
                  onClick={() => setActiveVideo(film.id)}
                >
                  <img
                    src={`https://img.youtube.com/vi/${film.id}/maxresdefault.jpg`}
                    alt="Wedding film"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-all flex items-center justify-center">
                    <div className="w-14 h-14 bg-white/90 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
                      <Play className="w-6 h-6 text-black ml-0.5" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </TabsContent>

          <TabsContent value="photos">
            <div className="columns-2 lg:columns-3 gap-3 space-y-3">
              {photos.map((src, i) => (
                <div
                  key={i}
                  data-testid={`photo-${i}`}
                  className="break-inside-avoid overflow-hidden rounded-xl cursor-pointer group"
                  onClick={() => setLightboxPhoto(src)}
                >
                  <img
                    src={src}
                    alt="Wedding photography"
                    className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </TabsContent>
        </Tabs>
      </div>

      {lightboxPhoto && (
        <div
          data-testid="photo-lightbox"
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4 cursor-pointer"
          onClick={() => setLightboxPhoto(null)}
        >
          <img src={lightboxPhoto} alt="" className="max-w-full max-h-[90vh] object-contain rounded-lg" />
        </div>
      )}
    </section>
  );
};

export default Portfolio;
